// import BScroll from 'better-scroll'
import BScroll from 'better-scroll'

import './index.scss'
// ua

// 判断是否APP环境
const IS_APP = window.$platform.isYixinliApp

const IS_PC = window.$platform.isPc

const setTransform = (el, y, r = 0) => {
  el.style.transform = `translate3d(0, ${y}, 0) rotate(${r}deg)`
  el.style.webkitTransform = `translate3d(0, ${y}, 0) rotate(${r}deg)`
}

const initCommentPage = (wrapper, scroll, wrapper2, scroll2) => {
  const downEl = document.querySelector('#pull-tips-down')
  const downrEl = downEl.querySelector('.pull-tips-round')
  const downtEl = downEl.querySelector('span')
  const upEl = document.querySelector('#pull-tips-up')
  const uprEl = upEl.querySelector('.pull-tips-round')
  const uptEl = upEl.querySelector('span')
  const cf = 50
  function scrolling() {
    const { y, maxScrollY } = scroll
    const space = maxScrollY - y
    if (space > 0) {
      const p = ((space / cf) * -100) / 4 + '%'
      if (y < maxScrollY - cf) {
        console.log('scroll1 setTransform(uprEl, 0) 1111111111')

        setTransform(uprEl, p, 180)
        uptEl.innerText = '释放查看更多留言'
      } else {
        console.log('scroll1 setTransform(uprEl, 0) 222222222')

        setTransform(uprEl, p)
        uptEl.innerText = '上拉查看更多留言'
      }
    }
  }
  function scrolling2() {
    const { y } = scroll2
    if (y > 0) {
      if (y > cf) {
        setTransform(downrEl, 0)
        downtEl.innerText = '释放返回顶部'
      } else {
        setTransform(downrEl, 0, 180)
        downtEl.innerText = '下拉返回顶部'
      }
    }
  }

  wrapper.addEventListener('touchmove', scrolling)
  scroll.on('touchEnd', function(e) {
    const { y, maxScrollY } = scroll
    setTransform(uprEl, 0)

    console.log('scroll1 setTransform(uprEl, 0) 33333')
    uptEl.innerText = '上拉查看更多留言'
    if (y < maxScrollY - cf) {
      document.body.classList.add('show-comment')
    }
  })
  wrapper2.addEventListener('touchmove', scrolling2)
  scroll2.on('touchEnd', function(e) {
    const { y } = scroll2
    setTransform(downrEl, 0, 180)

    console.log('scroll1 setTransform(downrEl, 0, 180) 3333333')

    downtEl.innerText = '下拉返回顶部'
    if (y > cf) {
      document.body.classList.remove('show-comment')
    }
  })
}

export default renderScroll2 =>
  new Promise(resolve => {
    console.log('function  renderScroll2', renderScroll2)
    let scrollConfig = {
      click: true,
      mouseWheel: {
        speed: 20,
        invert: false,
        easeTime: 300
      },
      preventDefaultException: {
        tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|OBJECT)$/
      }
    }
    if (IS_PC) {
      scrollConfig.scrollbar = {
        fade: false,
        interactive: true
      }
      // scrollConfig.useTransform = false // 修复在pc flash按钮错位的问题
    }
    setTimeout(
      () => {
        let wrapper = document.querySelector('#top-wrapper')

        console.log('init scroll1')
        let scroll = new BScroll(wrapper, scrollConfig)

        if (IS_APP) {
          new Bridge().call('isPullRefreshEnable', { enable: 0 })
        }

        // setInterval(() => {
        //   scroll.refresh()
        //   console.log('refresh')
        // }, 800)

        let scroll2
        if (renderScroll2) {
          let wrapper2 = document.querySelector('#bottom-wrapper')
          wrapper2.style.display = 'block'
          scroll2 = new BScroll(wrapper2, scrollConfig)
          initCommentPage(wrapper, scroll, wrapper2, scroll2)
        }
        resolve({ scroll, scroll2 })
      },
      process.env.NODE_ENV === 'production' ? 80 : 500
    ) // 开发环境style append 导致初始化的时候没有样式，所以延迟
  })



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/scroll/index.js